import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `A wave propagates from left to right or from right to left, whichever you choose. A change in cross section and/or medium can be designed, and its effect on the reflected and transmitted waves shows up in the reflection (R) and transmission (T) coefficients. The velocity field and the pressure field can be displayed with arrows and colors, respectively, or as a graph. The moving microphone pair records the pressure and velocity as a function of time (graph below). You can play with the type of propagating wave and with the boundary condition. In addition, pressure and velocity can be plotted without incident or reflected wave. Feel free to pause the motion to freeze the situation, and move the microphones to examine the time evolution of pressure and velocity at any position. Observe how changing the media, the tube section and the type/side of excitation affects the reflected and transmitted waves.\n<hr />\n <div style="display:flex;align-items:center;gap:10px">\n<i class="cil-comment-bubble-exclamation" style="font-size:21px"></i>\n<span style="font-size:10px;font-weight:700;line-height:16px">animation slowed down by 3000x, displacement multipled by 50000, medium: air, standing wave ratio: 7.32</span>\n</div>`,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 2,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0106/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
